import Image from "@Components/Image";
import Reveal from "@Components/Reveal/Reveal";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
import { TESTIMONIALS } from "./cards";
import styles from "./Testimonials.module.scss";
import cardStyles from "./QuoteCard.module.scss";

/**
 * "What our partners say" — the three partner quotes as a still row of the Career page's
 * testimonial card: the quote in a white block, the person in a grey strip beneath it.
 *
 * ⚠️  NOT THE RAIL ANY MORE. This used to hand `QUOTE_CARDS` to `Rail`, the scroll-snap carousel
 * that `CaseStudies` still uses. Three quotes fit side by side at desktop widths, so there is
 * nothing to scroll to and no controls to show; below `lg` the same row scrolls sideways (CSS
 * scroll-snap, no controls).
 *
 * The section frame (`.section`, `.inner`, `.heading`) is still `Testimonials.module.scss`, so the
 * band, its padding and the heading are unchanged. Only the cards are new.
 */
const Testimonials = () => {
  const { t } = useTranslationHook();

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <Reveal as="h2" className={styles.heading}>
          {t("list.v2.testimonials.heading")}
        </Reveal>

        <div className={cardStyles.row}>
          {TESTIMONIALS.map((person, i) => (
            <Reveal key={person.id} delay={i * 90} className={cardStyles.cell}>
              <figure className={cardStyles.card}>
                <div className={cardStyles.content}>
                  <blockquote className={cardStyles.quote}>{t(person.quote)}</blockquote>
                </div>
                <figcaption className={cardStyles.footer}>
                  {/* `alt=""` — the name is right beside it in text, and the avatar is an
                    illustration rather than a picture of the person. */}
                  <Image
                    src={person.avatar}
                    alt=""
                    className={cardStyles.avatar}
                    width={40}
                    height={40}
                  />
                  <div className={cardStyles.authorText}>
                    <p className={cardStyles.name}>{person.name}</p>
                    <p className={cardStyles.role}>{t(person.role)}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default wrapperHOC(Testimonials, {
  componentName: "Testimonials-ListWithUs",
  showForChina: true,
});
